import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Performance-Oriented Austin Software Company Helping Businesses
                Grow
              </h2>
            </div>
            <p>
              Our popular Austin software company is a team of expert developers
              working in cross-functional agile methodology with a transparent,
              and dedicated culture of tech evolution.{" "}
            </p>
            <p>
              We excel at crafting exceptional user experiences based on
              user-focused design and development techniques. Our commitment to
              solving challenges proactively with the use of Agile development
              methodologies allows us to build custom software that precisely
              caters to the unique requirements of a business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
